import usePermissions from "hooks/usePermissions";
import { useMemo } from "react";
import { useIntl } from "react-intl";

import { FilterConfig } from "types/Common";

export default function useProviderInvoiceFilters() {
  const intl = useIntl();
  const { permissions } = usePermissions();
  const { teams } = JSON.parse(permissions || "{}").provider_teams;
  const { accessible_companies } = JSON.parse(permissions || "{}");

  const INVOICE_DISPLAY_STATUS = useMemo(
    () => [
      {
        label: intl.formatMessage({ id: "general.unsubmitted", defaultMessage: "Unsubmitted" }),
        value: "Unsubmitted",
      },
      {
        label: intl.formatMessage({ id: "tabs.awaitingAudit", defaultMessage: "Awaiting Audit" }),
        value: "Awaiting_Audit",
      },
      {
        label: intl.formatMessage({ id: "tabs.approved", defaultMessage: "Approved" }),
        value: "Approved",
      },
      {
        label: intl.formatMessage({ id: "tabs.removed", defaultMessage: "Removed" }),
        value: "Removed",
      },
      {
        label: intl.formatMessage({ id: "tabs.autoRemoved", defaultMessage: "Auto Removed" }),
        value: "Auto_Removed",
      },
    ],
    [intl],
  );

  const config: FilterConfig[] = [
    {
      filterType: "multiselect",
      label: intl.formatMessage({ id: "general.displayStatus", defaultMessage: "Display status" }),
      key: "display_status",
      options: INVOICE_DISPLAY_STATUS,
    },
    {
      filterType: "multiselect",
      label: intl.formatMessage({ id: "general.team", defaultMessage: "Team" }),
      key: "team",
      isSearchable: true,
      options: teams,
    },
    {
      filterType: "freight_mode",
      label: intl.formatMessage({ id: "general.freightMode", defaultMessage: "Freight mode" }),
      key: "freight_mode",
      filterValueKey: "key",
    },
    {
      filterType: "multiselect",
      label: intl.formatMessage({ id: "general.shipper", defaultMessage: "Shipper" }),
      key: "shipper",
      isSearchable: true,
      options: accessible_companies.map((company: any) => ({
        value: company.id,
        label: company.name,
      })),
    },
  ];

  return { config };
}
